<script setup>
import CompBreadCrumbs from "@/components/CompBreadCrumbs";
import IconsComp from "@/components/IconsComp";
import CompPagination from "@/components/CompPagination";
import CompSearch from "@/components/CompSearch";
import CompDropdown from "@/components/CompDropdown";
import { CompDataLoad } from '@/components'
import { ref, onMounted, watch } from "vue";
import { useMonitorStore } from "@/stores";

const currentPage = ref(1);
const oldCurrentPage = ref(1)
const firstPage = ref(1);
const lastPage = ref(1);
const perPage = ref(20);
const paginationOnLoad = ref(false)
const monitors = ref([]);
const dataLoad = ref("Carregando..");
const search = ref('')
const ArrowIcons = ref([])

onMounted(async () => {
    await getMonitors();
});

watch(currentPage, async (newValue, oldValue) => {
    if (newValue != oldValue) {
        await getMonitors();
    }
});

watch(perPage, async (newValue, oldValue) => {
    if (newValue != oldValue) {
        await getMonitors();
    }
});

async function getMonitors() {
    monitors.value = [];
    dataLoad.value = "Carregando";

    paginationOnLoad.value = true
    monitors.value = await useMonitorStore().search(search.value, perPage.value, currentPage.value !== oldCurrentPage.value ? currentPage.value : 1)

    currentPage.value = monitors.value.meta?.current_page;
    oldCurrentPage.value = currentPage.value
    perPage.value = monitors.value.meta?.per_page;
    lastPage.value = monitors.value.meta?.last_page;
    monitors.value = monitors.value.data;

    monitors.value.length === 0
        ? (dataLoad.value = "Nenhuma monitor encontrado")
        : "";

    paginationOnLoad.value = false
}
</script>

<template>
    <div class="container mx-auto px-6 pt-10">
        <div class="flex justify-between flex-col md:flex-row items-center mb-8">
            <div class="hidden md:flex">
                <CompBreadCrumbs>
                    <template v-slot:default>
                        <li>
                            <router-link :to="{ name: 'painel-inovahc-monitores' }">
                                <IconsComp icon="user" class="w-6 h-6" />
                                Usuários
                            </router-link>
                        </li>
                    </template>
                </CompBreadCrumbs>
            </div>
            <div class="ml-auto">
                <router-link :to="{ name: 'adicionar-monitor' }" class="btn small btn-sm primary no-underline">Adicionar
                    novo</router-link>
            </div>
        </div>

        <div class="text-5xl font-bold font-poppins mb-8 text-purple-800">
            Gestão de usuários do sistema
        </div>
        <div>
            <ul class="menu-tabs">
                <li class="active">
                    <router-link :to="{ name: 'painel-inovahc-monitores' }">
                        Monitores
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'painel-inovahc-pareceristas' }">
                        Pareceristas
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'painel-inovahc-proponentes' }">
                        Proponentes
                    </router-link>
                </li>
            </ul>
        </div>
    </div>

    <div class="bg-purple-50">
        <div class="container mx-auto px-6 pt-8 mb-8">
            <div class="w-96 ml-auto max-w-full mb-4">
                <CompSearch @submit.prevent="getMonitors" name="search" v-model="search" placeholder="Buscar monitor" />
            </div>
            <div class="overflow-x-scroll lg:overflow-hidden rounded-lg border border-white shadow-md">
                <table class="table rounded">
                    <thead class="bg-gray-50">
                        <tr>
                            <th scope="col-2">
                                <div class="profile">
                                    Monitor
                                    <span>
                                        <IconsComp icon="filter-arrow-top" />
                                        <IconsComp icon="filter-arrow-down" />
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div>
                                    Telefone
                                    <span>
                                        <IconsComp icon="filter-arrow-top" />
                                        <IconsComp icon="filter-arrow-down" />
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <div>
                                    Instituto de origem
                                    <span>
                                        <IconsComp icon="filter-arrow-top" />
                                        <IconsComp icon="filter-arrow-down" />
                                    </span>
                                </div>
                            </th>
                            <th scope="col">
                                <span>Status</span>
                            </th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody v-show="monitors.length > 0" v-for="(monitor, i) in monitors" :key="i" class="bg-white border-t">
                        <tr class="hover:bg-white hover:text-purple-800">
                            <td>
                                <div class="profile w-96">
                                    <div class="profile-img small">
                                        <img v-if="monitor?.avatar" :src="monitor?.avatar" alt="" />
                                        <img v-else src="@/assets/img/template/profile2.png" alt="" />
                                    </div>
                                    <div>
                                        {{ monitor?.nome_completo }}

                                        <div class="text-gray-400 text-sm">
                                            {{ monitor?.email }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="w-48 truncate">
                                    {{ monitor?.telefone }}
                                </div>
                            </td>
                            <td>
                                <div>
                                    {{ monitor?.instituto?.nome }}
                                </div>
                            </td>
                            <td>
                                <router-link :to="{ name: 'painel-inovahc-monitor', params: { id: monitor.id } }"
                                    class="no-underline">
                                    <button type="button" class="tag" :class="monitor.inativo ? 'red' : 'blue'">
                                        {{ monitor.inativo ? 'Inativo' : "Ativo" }}
                                    </button>
                                </router-link>
                            </td>
                            <td class="relative lg:static">
                                <div class="flex justify-end items-center">
                                    <CompDropdown alignment="right" divStyle="absolute" class="mr-8">
                                        <template #toggle>
                                            <IconsComp icon="more" class="w-6 h-6 fill-green-500" />
                                        </template>
                                        <router-link :to="{
                                            name: 'painel-inovahc-monitor',
                                            params: { id: monitor.id },
                                        }">
                                            <li class="text-purple-800">
                                                Visualizar monitor
                                            </li>
                                        </router-link>
                                    </CompDropdown>
                                    <div class="ml-auto">
                                        <button @click.prevent="ArrowIcons[i] = !ArrowIcons[i]">
                                            <IconsComp :class="{ 'rotate-180': ArrowIcons[i] }" icon="arrow-down"
                                                class="transition-all duration-300 fill-green-500 w-6 h-6 ml-12 xl:ml-2" />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="ArrowIcons[i]" :class="{ 'opacity-100': ArrowIcons[i] }"
                            class="transition-opacity duration-800 delay-150 ease-in opacity-0 hover:bg-white hover:text-purple-800">
                            <td colspan="1000">
                                <div class="grid grid-cols-4 gap-x-10 ml-10">
                                    <div>
                                        <div class="text-gray-400 text-sm mb-2">
                                            Capacidade de projetos
                                        </div>
                                        <p v-if="monitor.instituto">
                                            {{ monitor.instituto.numero_maximo_projetos }} projeto(s)
                                        </p>
                                        <p v-else>-</p>
                                    </div>
                                    <div class="col-span-3">
                                        <div class="text-gray-400 text-sm mb-2">Especialidades</div>
                                        <p>
                                            {{
                                                monitor.especialidades
                                                ? monitor.especialidades
                                                    .map((obj) => obj.nome)
                                                    .join(", ")
                                                : "-"
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-show="monitors.length === 0">
                        <tr>
                            <td colspan="1000">
                                <CompDataLoad :dataLoad="dataLoad" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-4 pb-20">
                <div class="container mx-auto px-6">
                    <CompPagination :onLoad="paginationOnLoad" v-model:quantity="perPage" v-model:page="currentPage"
                        :firstPage="firstPage" :lastPage="lastPage" />
                </div>
            </div>
        </div>
    </div>
</template>
